import { defineMessages } from 'react-intl';

export default defineMessages({
    inForce:{
        id:"gateway.policyclaim.In Force",
        defaultMessage:"In Force"  
    }

})   